import { render } from "./RequestSickLeave.vue?vue&type=template&id=336a70ac&scoped=true"
import script from "./RequestSickLeave.vue?vue&type=script&lang=js"
export * from "./RequestSickLeave.vue?vue&type=script&lang=js"

import "./RequestSickLeave.vue?vue&type=style&index=0&id=336a70ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336a70ac"]])

export default __exports__